/**
 * Résout une URL de service public (Suite, module, PEP…).
 *
 * - Développement : fallback localhost autorisé.
 * - Production : la variable VITE_* doit être injectée au build — pas de fallback silencieux.
 */
function isProductionBuild() {
    const env = import.meta.env;
    return env?.PROD === true;
}
export function resolvePublicServiceUrl(envUrl, envVarName, devFallback) {
    const trimmed = envUrl?.trim();
    if (isProductionBuild() && !trimmed) {
        throw new Error(`Missing ${envVarName} in production build.`);
    }
    const url = trimmed || devFallback;
    if (!url) {
        throw new Error(`Missing ${envVarName} (no dev fallback configured).`);
    }
    return url.replace(/\/$/, "");
}
